import Image from 'next/image';
import type { IntlShape } from 'react-intl';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { GOOGLE_PLAY_URL_MAP } from '../Footer/StoreBadges/GooglePlay';

type StackedGooglePlayBadgeProps = {
  intl: IntlShape;
  languageRegionCode: LanguageRegionCode;
  height?: number;
};

// uniform-width Google Play badge, sized to stack with StackedAppStoreBadge
const StackedGooglePlayBadge = ({ intl, languageRegionCode, height = 54 }: StackedGooglePlayBadgeProps) => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports, import/no-dynamic-require
  const src = require(`./app-google-${languageRegionCode}.svg`).default;

  return (
    <a href={GOOGLE_PLAY_URL_MAP[languageRegionCode]} target="_blank" rel="noreferrer">
      <Image alt={intl.formatMessage({ defaultMessage: 'Download the AllTrails application on Google Play' })} height={height} src={src} />
    </a>
  );
};

export default StackedGooglePlayBadge;
